import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Statement = ({ icon, title, bullet1, bullet2 }) => {
    return (
        <Grid 
            size={{xs:12, sm:12, md:4}}
            sx={{ 
                justifyContent: 'left', 
                textAlign: 'left', 
                marginLeft:{xs:"1.2REM", sm:"1.2REM", md:"0REM"}, 
                marginRight:{xs:"1.2REM", sm:"1.2REM", md:"0REM"}, 
                marginBottom: 5 }}>
            <img src={icon} alt={icon} width="36px"/>
            <Typography fontSize={"1.5REM"} flexWrap={true} fontWeight={"Bold"} color='#333333' textAlign='left'>
                {title}
            </Typography>
            <Typography fontSize={"1.2REM"} flexWrap={true} fontWeight={"Thin"} color='#333333' textAlign='left'>
                1. {bullet1}
            </Typography>
            <Typography fontSize={"1.2REM"} flexWrap={true} fontWeight={"Thin"} color='#333333' textAlign='left'>
                2. {bullet2}
            </Typography>
        </Grid>
    );
};

const GettingStartedSection = () => {
    return (
        <Container sx={{marginBottom: 10, marginTop: 10}}>
            <Box sx={{ textAlign: 'center', marginBottom: 1}}>
                <Typography 
                    variant="h4" 
                    sx={{ 
                        textAlign: "center",
                        fontSize: 36, 
                        fontWeight: 600, // semi-bold
                        color: '#111111', 
                        marginBottom: 5
                    }}
                >Getting started with Sigmatiqa.
                </Typography>
                <Grid
                    container
                    spacing={10}
                >
                    <Statement icon={"./checklist.png"} title="Survey Monitoring Points." bullet1="Identify and document all pipe sections requiring temperature monitoring." bullet2="Consult with us to determine the optimal number and placement of gateways based on your site layout." />
                    <Statement icon={"./fittings.png"} title="Install Hardware." bullet1="Attach our clamp-on probes securely using self-amalgamating tape." bullet2="Connect each probe to its respective sensor for accurate data capture." />
                    <Statement icon={"./dashboard.png"} title="Provision Dashboard." bullet1="Power on the gateways and connect them to the internet." bullet2="Assign names and locations to each sensor within the dashboard for easy identification and tracking." />
                </Grid>
            </Box>
        </Container>
    );
};

export default GettingStartedSection;